<template>
    <div class="family-search-header-toggle pa-flex pa-items-center">
        <!--Previous-->
        <button :disabled="disabledPre" class="th-btn th-btn-outline th-btn-sm pa-shrink-0" @click="togglePre">
            <svg width="20" height="20" class="th-btn-icon">
                <use xlink:href="#SolidArrowLeft" />
            </svg>
            <span>{{ $t('highlight.Previous') }}</span>
        </button>
        <!--Index-->
        <span class="pa-mx-2 pa-shrink-0 pa-text-[12px] pa-text-gray-90">{{ index }}/{{ total }}</span>
        <!--Next-->
        <button :disabled="disabledNext" class="th-btn th-btn-outline th-btn-sm pa-shrink-0" @click="toggleNext">
            <span>{{ $t('highlight.Next') }}</span>
            <svg width="20" height="20" class="th-btn-icon pa-rotate-180">
                <use xlink:href="#SolidArrowLeft" />
            </svg>
        </button>
    </div>
</template>

<script setup lang="ts">
import '@patsnap-ui/icon/assets/solid/ArrowLeft.svg';
import { useFamilySearchPage } from '@/composables/use-family-search-page';

const { index, total, disabledPre, disabledNext, togglePre, toggleNext } = useFamilySearchPage();
</script>

<style lang="scss">

</style>
